export const DEFAULT_ASSIGN = 'DEFAULT_ASSIGN';
export const SET_LOGIN_INFO = 'SET_LOGIN_INFO';
export const SET_USER_MESSAGE = 'SET_USER_MESSAGE';
export const SET_INIT_STORE = 'SET_INIT_STORE';
export const SET_SESSION_TIMER = 'SET_SESSION_TIMER';
export const SET_SCREEN_TIMER = 'SET_SCREEN_TIMER';
export const SET_MENU_MAP = 'SET_MENU_MAP';
export const SET_SCREEN = 'SET_SCREEN';
